"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Star = void 0;
const PIXI = __importStar(require("pixi.js"));
const numbers_1 = require("@kennethgomez/utils/numbers");
const star_texture_generator_1 = require("./texture/star-texture-generator");
class Star {
    _position;
    _size;
    _brightness;
    _color;
    _cloned;
    /**
     * Star colors matrix on which every (0, y) is probability
     * and (x, 1) is color. If the probability sum is lower than
     * 100 all the rest colors will be filled by the latest color
     *
     * @member Array
     */
    static STAR_COLORS = [
        [2, 0xEFD4AB],
        [2, 0xEFABAB],
        [10, 0xEFABE8],
        [30, 0xABCDEF],
        [30, 0xFFFFFF], // white
    ];
    static _starColors = Star._computeStarColorProbabilities();
    _sprite;
    // eslint-disable-next-line no-useless-constructor
    constructor(_position, _size, _brightness, _color, _cloned = false) {
        this._position = _position;
        this._size = _size;
        this._brightness = _brightness;
        this._color = _color;
        this._cloned = _cloned;
        this._sprite = this._buildSprite();
    }
    clone() {
        const star = new Star(this._position, this._size, this._brightness, this._color, true);
        star.sprite.x = this._position.x;
        star.sprite.y = this._position.y;
        this._sprite.parent.addChild(star.sprite);
        return star;
    }
    destroy() {
        this._sprite.destroy({ children: true });
    }
    _buildSprite() {
        const texture = star_texture_generator_1.StarTextureGenerator.base;
        const { position: { x, y }, size, color, } = this;
        const star = new PIXI.Sprite(texture);
        star.blendMode = PIXI.BLEND_MODES.SATURATION;
        star.x = x - size / 2;
        star.y = window.innerHeight;
        star.scale.set(size);
        star.tint = color;
        // Initialize alpha as 0 so that we can make use of fadeIn animations
        star.alpha = 0;
        return star;
    }
    static random() {
        const { innerWidth, innerHeight } = window;
        // We divide by 4 so that the star brightness is always lower than 50%
        const brightness = (0, numbers_1.getBetween)(20, 0xFF / 4);
        // Given probability get size
        const size = (0, numbers_1.getBetween)(1, 10) === 1 ? 2 : 1;
        const colorIdx = (0, numbers_1.getBetween)(0, 100);
        const color = this._starColors[colorIdx];
        return new Star({
            x: (0, numbers_1.getBetween)(0, innerWidth),
            y: (0, numbers_1.getBetween)(0, innerHeight),
        }, size, brightness, color);
    }
    static _computeStarColorProbabilities() {
        const colorProbabilities = this.STAR_COLORS;
        const lastColor = colorProbabilities[colorProbabilities.length - 1][1];
        const colors = Array(100).fill(lastColor);
        let lastIdx = 0;
        for (const [p, c] of colorProbabilities) {
            colors.fill(c, lastIdx, p);
            lastIdx += p;
        }
        return colors;
    }
    get position() {
        return this._position;
    }
    get size() {
        return this._size;
    }
    get brightness() {
        return this._brightness;
    }
    get color() {
        return this._color;
    }
    get sprite() {
        return this._sprite;
    }
    get cloned() {
        return this._cloned;
    }
}
exports.Star = Star;
